<script setup lang="ts">
import type { LinkEditModel } from "../../links/types";
import type { BlockCardNodeViewProps, InlineCardNodeViewProps } from "./cards/types";
import type { LinkNodeAttributes, LinkNodeNodeViewProps } from "./types";
import { computed } from "vue";
import BlockCard from "./cards/BlockCard";
import EmbedEditor from "./cards/EmbedLinkEditor.vue";
import LinkEditor from "./LinkEditor.vue";

const props = defineProps<LinkNodeNodeViewProps | InlineCardNodeViewProps | BlockCardNodeViewProps>();
const emit = defineEmits<{
  close: [];
}>();

const isBlockCard = computed(() => {
  return props.node.type.name === BlockCard.name;
});

function commitChanges(attributes: Partial<LinkNodeAttributes>) {
  props.updateAttributes(attributes);
  emit("close");
}

function cancel() {
  emit("close");
  props.editor.commands.focus();
}

function embedEditorSubmit(url: string) {
  commitChanges({ url });
}

function linkEditorSubmit(model: LinkEditModel) {
  commitChanges({
    text: model.text,
    url: model.url,
  });
  props.editor.commands.focus();
}
</script>

<template>
  <EmbedEditor
    v-if="isBlockCard"
    :url="props.node.attrs.url"
    @submit="embedEditorSubmit"
    @cancel="cancel"
  />
  <LinkEditor
    v-else
    :url="props.node.attrs.url"
    :text="props.node.attrs.text ?? undefined"
    @submit="linkEditorSubmit"
    @cancel="cancel"
  />
</template>
